import { Channel, User } from "@prisma/client";
import clsx from "clsx";
import Link from "next/link";
import { ReactNode } from "react";

import { ChannelFragment } from "@/generated/generated-hooks";

type ChannelLinkProps = {
  channel:
    | ChannelFragment
    | (Channel & {
        creator: User;
      });
  onClick: () => void;
  children?: ReactNode;
  linkClassName?: string;
};

export function ChannelLink({
  channel,
  onClick,
  children,
  linkClassName,
}: ChannelLinkProps) {
  const { creator, title } = channel;

  return (
    <Link
      href={{ pathname: `/@${creator.accountName}/channel/${channel.slug}` }}
    >
      <a className={clsx("flex-grow", linkClassName)} onClick={onClick}>
        {children ?? (
          <span className="rounded-lg bg-gray-100 text-gray-700 text-xs px-2 py-1">
            {title}
          </span>
        )}
      </a>
    </Link>
  );
}
